import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-white gap-3" }
const _hoisted_2 = { class: "flex flex-col items-center px-6 py-8" }
const _hoisted_3 = { class: "mt-0 font-medium text-lg text-gray-900 text-center" }
const _hoisted_4 = { class: "font-normal text-sm text-gray-600 my-4 text-center" }



// Define props

export default /*#__PURE__*/_defineComponent({
  __name: 'TutorialModalComponent',
  props: {
    show: { type: Boolean }
  },
  emits: ["update:show"],
  setup(__props: any, { emit }) {

const props = __props;



// Define emits


// Handle close event
const handleClose = () => {
  console.log("Closing modal");
  emit("update:show", false); // Emit event to close the modal
};

// Function to update the show property
const updateShow = (value: boolean) => {
  emit("update:show", value);
};

return (_ctx: any,_cache: any) => {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    showCloseButton: true,
    widthClass: 'max-w-xl px-4 py-6 rounded-lg',
    open: _ctx.show,
    onLocalModalOpen: _cache[0] || (_cache[0] = ($event: any) => (updateShow($event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, [
            _renderSlot(_ctx.$slots, "headerSlot")
          ]),
          _createElementVNode("p", _hoisted_4, [
            _renderSlot(_ctx.$slots, "descriptionSlot")
          ]),
          _renderSlot(_ctx.$slots, "strapiContent")
        ])
      ])
    ]),
    _: 3
  }, 8, ["open"]))
}
}

})